import { useCallback, useState } from 'react'

const useHistoricalDetail = () => {
  const [openHistoricalDetail, setOpenHistoricalDetail] = useState(false)
  const [historicalDetail, setHistoricalDetail] = useState(null)
  const onCLickHistorical = useCallback((value) => {
    setOpenHistoricalDetail(true)
    setHistoricalDetail(value)
  }, [])
  const onCloseHistorical = () => {
    setOpenHistoricalDetail(false)
    setHistoricalDetail(null)
  }

  return {
    openHistoricalDetail,
    historicalDetail,
    onCLickHistorical,
    onCloseHistorical,
  }
}

export default useHistoricalDetail
